import React, { useEffect, useState } from 'react';
import { authorInitials, resolveAuthorColor } from '../../platform/chatAuthorColors';
import { resolvePhotoCandidate } from '../../utils/photoUtils';

export default function ProfileAvatar({
  uid,
  photoURL,
  displayName,
  authorColor,
  className = '',
  photoClassName = '',
  initialsClassName = '',
  style,
}) {
  const candidatePhotoURL = resolvePhotoCandidate(photoURL);
  const [resolvedPhotoURL, setResolvedPhotoURL] = useState(candidatePhotoURL);
  const initials = authorInitials(displayName);
  const resolvedAuthorColor = resolveAuthorColor(uid, authorColor);

  useEffect(() => {
    setResolvedPhotoURL(candidatePhotoURL);
  }, [candidatePhotoURL]);

  if (resolvedPhotoURL) {
    return (
      <img
        src={resolvedPhotoURL}
        alt=""
        className={photoClassName || className}
        style={style}
        onError={() => setResolvedPhotoURL('')}
      />
    );
  }

  return (
    <div
      className={initialsClassName || className}
      style={{ backgroundColor: resolvedAuthorColor, ...style }}
      aria-hidden="true"
    >
      {initials}
    </div>
  );
}
